if (!customElements.get('jubilo-grados')) {
  customElements.define('jubilo-grados', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.models = [...this.querySelectorAll('[data-model]')];
      this.panels = [...this.querySelectorAll('[data-preview]')];
      this.details = [...this.querySelectorAll('[data-detail]')];
      this.correlonSelect = this.querySelector('[data-correlon-select]');
      this.button = this.querySelector('[type="submit"]');
      this.message = this.querySelector('[data-message]');
      this.busy = false;
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      this.querySelectorAll('img').forEach(img => img.addEventListener('error', () => {
        img.closest('[data-preview], [data-detail]').dataset.imageFailed = 'true';
        this.update();
      }));
      this.update();
      this.previewResize = new ResizeObserver(() => this.fitPrint());
      this.previewResize.observe(this.querySelector('.jg-preview'));
      this.previewResize.observe(this.querySelector('.jg-detail-wrap'));
      document.fonts.ready.then(() => this.fitPrint());
    }
    disconnectedCallback() {
      this.previewResize?.disconnect();
    }
    fitPrint() {
      if (!this.detail) return;
      this.detail.querySelectorAll('.jg-print').forEach(text => {
        text.style.fontSize = '';
        if (text.clientWidth && text.scrollWidth > text.clientWidth) {
          const size = parseFloat(getComputedStyle(text).fontSize);
          text.style.fontSize = `${size * text.clientWidth / text.scrollWidth * 0.97}px`;
        }
      });
    }
    update() {
      this.current = this.models.find(model => model.checked);
      if (!this.current) return;
      this.panel = this.panels.find(panel => panel.dataset.preview === this.current.value);
      this.panels.forEach(panel => { panel.hidden = panel !== this.panel; });
      this.detail = this.details.find(panel => panel.dataset.detail === this.current.value);
      this.details.forEach(panel => { panel.hidden = panel !== this.detail; });
      const isCorrelon = this.current.dataset.family === 'correlones';
      this.querySelector('[data-correlon-picker]').hidden = !isCorrelon;
      this.saleChoice = isCorrelon ? this.correlonSelect.selectedOptions[0] : this.current;
      if (isCorrelon) {
        const photo = this.panel.querySelector('img');
        const imageUrl = this.saleChoice?.dataset.image;
        if (photo && imageUrl && photo.getAttribute('src') !== imageUrl) {
          this.panel.dataset.imageFailed = 'false';
          photo.removeAttribute('srcset');
          photo.src = imageUrl;
          photo.alt = this.saleChoice.dataset.label;
        }
      }
      const other = this.form.elements.color_choice.value === 'other';
      this.querySelector('[data-other]').hidden = !other;
      const color = other ? this.form.elements.custom_color.value : '#D4AF37';
      this.details.forEach(panel => {
        panel.style.setProperty('--print-color', color);
        const name = panel.querySelector('[data-name]');
        const degree = panel.querySelector('[data-degree]');
        if (name) name.textContent = this.form.elements.person_name.value;
        if (degree) degree.textContent = this.form.elements.degree.value;
      });
      for (const field of ['person_name', 'degree']) {
        this.querySelector(`[data-count="${field}"]`).textContent = `${this.form.elements[field].value.length}/15`;
      }
      this.querySelector('[data-total-price]').textContent = this.saleChoice?.dataset.price || this.current.dataset.price;
      this.ready = this.saleChoice?.dataset.ready === 'true' && this.panel.dataset.imageFailed !== 'true' && this.detail?.dataset.imageFailed !== 'true';
      this.button.disabled = !this.ready || this.busy;
      this.querySelector('[data-unavailable]').hidden = this.ready;
      this.fitPrint();
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.ready || !this.form.reportValidity()) return;
      const name = this.form.elements.person_name.value.trim();
      const degree = this.form.elements.degree.value.trim();
      if (!name || !degree || name.length > 15 || degree.length > 15) {
        this.message.textContent = this.dataset.validation;
        return;
      }
      this.busy = true;
      this.button.disabled = true;
      this.message.textContent = this.dataset.adding;
      let added = false;
      const selection = this.saleChoice || this.current;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({items: [{id: Number(selection.dataset.variant), quantity: 1, properties: {
            'Nombre': name,
            'Texto de grado': degree,
            'Color del estampado': this.form.elements.color_choice.value === 'other' ? this.form.elements.custom_color.value.toUpperCase() : 'Dorado (#D4AF37)',
            'Modelo de grado': selection.dataset.label,
            'Ubicación del nombre': this.panel.dataset.namePlacement,
            'Ubicación del grado': this.panel.dataset.degreePlacement,
            'Incluye': 'Empaque, birrete, toga y dos estampados'
          }}]})
        });
        if (!response.ok) throw new Error('cart');
        added = true;
        window.location.assign(this.dataset.cartUrl);
      } catch {
        this.message.textContent = this.dataset.error;
      } finally {
        if (!added) {
          this.busy = false;
          this.update();
        }
      }
    }
  });
}
